import script from "./SupplierStatement.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierStatement.vue?vue&type=script&setup=true&lang=js"

import "./SupplierStatement.vue?vue&type=style&index=0&id=d1b232ae&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1b232ae"]])

export default __exports__